import {
  type OfferPriceV1,
  PrescriptionPrescriptionTypeEnum,
} from '@redteclab/api/clients/bully'

import { priceAccessorIsPrescription } from './priceAccessorIsPrescription'

export const priceAccessorShouldDisplayStrikeThroughPrice = ({
  currentPrescriptionType,
  displayPrice,
  isDiscountValid,
  strikeThroughOfferPrice,
}: {
  currentPrescriptionType: PrescriptionPrescriptionTypeEnum
  displayPrice: OfferPriceV1 | null
  isDiscountValid: boolean
  strikeThroughOfferPrice: OfferPriceV1 | null
}): boolean => {
  if (
    currentPrescriptionType !== PrescriptionPrescriptionTypeEnum.NoPrescription
  ) {
    return false
  }

  const isPrescriptionDiscount = priceAccessorIsPrescription(
    currentPrescriptionType,
  )
  const isListPriceGreaterThanRealPrice =
    (strikeThroughOfferPrice?.price ?? 0) > (displayPrice?.price ?? 0)

  const showListPrice =
    isPrescriptionDiscount && isListPriceGreaterThanRealPrice

  return (
    (showListPrice || (!isPrescriptionDiscount && isDiscountValid)) &&
    Boolean(strikeThroughOfferPrice)
  )
}
